import { c as _c } from "react/compiler-runtime";
import React from "react";
import IInput from "@/app/components/Common/Input";
import { PlusIcon } from "@/app/components/UI/Icons";
import type { AmountInputViewModel } from "./types";
export default function AmountInputDefaultView(t0) {
  const $ = _c(18);
  const {
    field,
    balance,
    error,
    hint
  } = t0;
  let t1;
  if ($[0] !== balance.onActionButtonClick || $[1] !== balance.onMaxClick || $[2] !== balance.showActionButton || $[3] !== balance.title || $[4] !== balance.value || $[5] !== balance.visible) {
    t1 = balance.visible && <div className="absolute top-0 end-0 flex items-center gap-x-0.5 z-10"><span className="text-charcoal-600 text-xs font-normal">{balance.title} :</span><button type="button" className="px-1 text-bluetiful-400 text-xs font-semibold underline font-en" onClick={balance.onMaxClick}>{balance.value}</button>{balance.showActionButton && <button type="button" onClick={balance.onActionButtonClick}><PlusIcon className="h-6 w-6" /></button>}</div>;
    $[0] = balance.onActionButtonClick;
    $[1] = balance.onMaxClick;
    $[2] = balance.showActionButton;
    $[3] = balance.title;
    $[4] = balance.value;
    $[5] = balance.visible;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== field) {
    t2 = <IInput {...field} />;
    $[7] = field;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== error) {
    t3 = error && <span className="absolute -bottom-6 start-0 text-xs text-rojo-400 font-normal">{error}</span>;
    $[9] = error;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== hint) {
    t4 = hint && <div className="w-full absolute -bottom-6 start-0 text-charcoal-600 text-xs">{hint}</div>;
    $[11] = hint;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <div className="w-full relative">{t1}{t2}{t3}{t4}</div>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}